var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Custom-tableContainer"},[_c('div',[(_vm.showHeader)?_c('SubMenu',{attrs:{"items":_vm.MenuOptions.contexts.samples.itemsByArea[_vm.showHeader]}}):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"id":"report-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }